<template>
    <div role="tabcard" class="tab-pane" id="templates">
        <template-list :role="role" :user="user"></template-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        watch: {
        },

        computed: {
            
        },

        methods: {
        }
    }
</script>
